export default __webpack_public_path__ + "static/sc-customize-tags-edit-2fd04081a7df549d834163217a118ce5.mp4";